import { CircularProgress, IconButton } from '@mui/material';
import classNames from 'classnames';
import React from 'react';
import { Iconify } from 'src/components/iconify';

type Props = {
  icon: string;
  size?: number;
  color?: any;
  disabled?: boolean;
  loading?: boolean;
  actionAlwaysVisible?: boolean;
  onClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
};

export const NavActionButton = ({
  icon,
  size = 20,
  color = 'inherit',
  disabled = false,
  loading = false,
  onClick,
  actionAlwaysVisible,
}: Props) => {
  return (
    <IconButton
      size="small"
      color={color}
      onClick={onClick}
      disabled={disabled}
      className={classNames({ hoverOnly: !actionAlwaysVisible })}
    >
      {loading ? (
        <CircularProgress size={size} />
      ) : (
        <Iconify icon={icon} width={size} height={size} />
      )}
    </IconButton>
  );
};
